// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
var ref = allVue.ref;
import { getRef, Icon, kendoThemeMaps, setRef } from '@progress/kendo-vue-common';
import { searchIcon } from '@progress/kendo-svg-icons';
var sizeMap = kendoThemeMaps.sizeMap,
  roundedMap = kendoThemeMaps.roundedMap;
/**
 * @hidden
 */
var ListFilterVue2 = {
  name: 'list-filter',
  // @ts-ignore
  emits: {
    keydown: null,
    change: null
  },
  props: {
    value: String,
    rounded: {
      type: String,
      default: 'medium',
      validator: function validator(value) {
        return ['small', 'medium', 'large', 'full'].includes(value);
      }
    },
    fillMode: {
      type: String,
      default: 'solid',
      validator: function validator(value) {
        return ['solid', 'flat', 'outline'].includes(value);
      }
    },
    size: {
      type: String,
      default: 'medium',
      validator: function validator(value) {
        return ['small', 'medium', 'large'].includes(value);
      }
    }
  },
  computed: {
    spanClass: function spanClass() {
      var _a;
      var _b = this.$props,
        size = _b.size,
        rounded = _b.rounded,
        fillMode = _b.fillMode;
      return _a = {
        'k-searchbox k-input': true
      }, _a["k-input-".concat(sizeMap[size] || size)] = size, _a["k-rounded-".concat(roundedMap[rounded] || rounded)] = rounded, _a["k-input-".concat(fillMode)] = fillMode, _a;
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    var inputRef = ref(null);
    return {
      v3: v3,
      inputRef: inputRef
    };
  },
  methods: {
    onKeyDown: function onKeyDown(e) {
      this.$emit('keydown', e);
    },
    onChange: function onChange(e) {
      this.$emit('change', e);
    }
  },
  mounted: function mounted() {
    this.input = getRef(this, 'input');
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    return h("span", {
      "class": "k-list-filter"
    }, [h("span", {
      "class": this.spanClass
    }, [h(Icon, {
      name: "search",
      attrs: this.v3 ? undefined : {
        name: "search",
        icon: searchIcon
      },
      icon: searchIcon,
      "class": "k-input-icon"
    }), h("input", {
      ref: setRef(this, 'input'),
      type: "text",
      attrs: this.v3 ? undefined : {
        type: "text"
      },
      value: this.v3 ? this.$props.value || '' : null,
      domProps: this.v3 ? undefined : {
        "value": this.$props.value || ''
      },
      "class": "k-input-inner",
      onInput: this.onChange,
      on: this.v3 ? undefined : {
        "input": this.onChange,
        "keydown": this.onKeyDown
      },
      onKeydown: this.onKeyDown
    })])]);
  }
};
/**
 * @hidden
 */
var ListFilter = ListFilterVue2;
export { ListFilter, ListFilterVue2 };